export class RequestNoReq{
    requestNo:number;
    action:string;
    sampreqId?:number;
    userId?:number;
}

export class requestNoReq{
    requestNo:number;
}